import { render, staticRenderFns } from "./MicrophoneSelector.vue?vue&type=template&id=e8c509ae&scoped=true&"
import script from "./MicrophoneSelector.vue?vue&type=script&lang=js&"
export * from "./MicrophoneSelector.vue?vue&type=script&lang=js&"
import style0 from "./MicrophoneSelector.vue?vue&type=style&index=0&id=e8c509ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c509ae",
  null
  
)

/* custom blocks */
import block0 from "./MicrophoneSelector.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./MicrophoneSelector.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports